// @flow

import {
  type RecordFactory,
  type RecordInstance,
  Record,
  Map,
  fromJS,
} from 'immutable';

import type {NotificationType} from './types';
import {
  type NotificationsAction,
  REQUEST_NOTIFICATIONS,
  RECEIVE_NOTIFICATIONS_LIST,
  RECEIVE_NOTIFICATIONS_STATS,
} from './actions';
import {setNormalizedList} from 'app/utils/redux_v2';

import {hasCurrentUserData} from 'app/current-user/api';

type StateShape = {
  isFetching: boolean,
  isVisible: boolean,
  notificationsModifiedAt: null | string,
  numNotifications: number,
  byId: {[string]: NotificationType},
  queries: {[string]: any},
  dashboard: {currentFilters: {[string]: any}},
};

const StateFactory: RecordFactory<StateShape> = Record({
  isFetching: false,
  hideBanner: null,
  isVisible: true,
  notificationsModifiedAt: null,
  numNotifications: 0,

  // v2 reducers
  byId: {},
  queries: {},
  dashboard: {
    currentFilters: Map(),
  },
});

export type RecordOfNotificationsState = RecordInstance<StateShape>;

const notifications = (
  state: RecordOfNotificationsState = StateFactory(),
  action: NotificationsAction
): RecordOfNotificationsState => {
  if (hasCurrentUserData(action)) {
    return state.merge({
      notificationsModifiedAt: action.payload.notifications_modified_at,
      numNotifications: action.payload.num_notifications,
    });
  }

  switch (action.type) {
    case REQUEST_NOTIFICATIONS:
      return state
        .set('isFetching', true)
        .setIn(['dashboard', 'currentFilters'], fromJS(action.currentFilters));

    case RECEIVE_NOTIFICATIONS_LIST:
      return setNormalizedList(action.query, action.response, state).set(
        'isFetching',
        false
      );

    case RECEIVE_NOTIFICATIONS_STATS:
      return state.merge({
        notificationsModifiedAt: action.data['notifications_modified_at'],
        numNotifications: action.data['num_notifications'],
      });

    default:
      return state;
  }
};

export default notifications;
